module.exports = __webpack_public_path__ + "static/img/bj14.310e570.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/bj14.png
// module id = K+UU
// module chunks = 0